(() => {
  const selector = 'input[data-search-suggestions]';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initialise = (input) => {
    if (input.dataset.searchSuggestionsReady === 'true') return;

    const suggestions = (input.dataset.searchSuggestions || '')
      .split('|')
      .map((suggestion) => suggestion.trim())
      .filter(Boolean);

    if (!suggestions.length) return;

    input.dataset.searchSuggestionsReady = 'true';
    const prefix = input.dataset.searchSuggestionPrefix || '';
    let suggestionIndex = 0;
    let rotationTimer;

    const setSuggestion = () => {
      input.placeholder = `${prefix}${suggestions[suggestionIndex]}`;
    };

    const scheduleRotation = () => {
      window.clearTimeout(rotationTimer);
      if (reduceMotion.matches || suggestions.length < 2 || !input.isConnected) return;
      rotationTimer = window.setTimeout(rotateSuggestion, 2800);
    };

    const rotateSuggestion = () => {
      if (!input.isConnected) return;

      if (document.hidden || input.value) {
        scheduleRotation();
        return;
      }

      input.classList.add('search-suggestion-changing');
      window.setTimeout(() => {
        if (!input.isConnected) return;
        suggestionIndex = (suggestionIndex + 1) % suggestions.length;
        setSuggestion();
        requestAnimationFrame(() => input.classList.remove('search-suggestion-changing'));
        scheduleRotation();
      }, 180);
    };

    input.addEventListener('input', () => {
      input.classList.remove('search-suggestion-changing');
      scheduleRotation();
    });

    setSuggestion();
    scheduleRotation();
  };

  const initialiseAll = (scope = document) => {
    scope.querySelectorAll(selector).forEach(initialise);
  };

  initialiseAll();
  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
